import { useTranslation } from "react-i18next";

interface ThemeToggleProps {
  isDark: boolean;
  onToggle: () => void;
  className?: string;
}

export function ThemeToggle({
  isDark,
  onToggle,
  className = "",
}: ThemeToggleProps) {
  const { t } = useTranslation();
  return (
    <button
      onClick={onToggle}
      className={`p-2 rounded-xl cursor-pointer border-[3px] border-ink shadow-board-sm press ${isDark ? "bg-zinc-900 text-gold" : "bg-white text-gray-900"} ${className}`}
      data-testid="theme-toggle"
      title={
        isDark
          ? t("components.themeToggle.light")
          : t("components.themeToggle.dark")
      }
    >
      {isDark ? (
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
          />
        </svg>
      ) : (
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
          />
        </svg>
      )}
    </button>
  );
}
